import { CompanyCell } from "./CompanyCell/CompanyCell";
import { InvestorsCell } from "./InvestorsCell/InvestorsCell";
import { FinancialStageCell } from "./FinancialStageCell/FinancialStageCell";
import { ValuationCell } from "./ValuationCell/ValuationCell";
import { TotalFundingCell } from "./TotalFundingCell/TotalFundingCell";
import { LocationCell } from "./LocationCell/LocationCell";
import { WebsiteCell } from "./WebsiteCell/WebsiteCell";
import styles from "./RowCell.module.scss";
import { headers } from "../TableLabels/const/const";
import { FoundingDateCell } from "./FoundingDateCell/FoundingDateCell";
import { TCompany, TTableCompany } from "@/frontend/features/Company/model/types/types";
import { ReactNode, useState } from "react";
import { DropshadowMenu } from "../../../DropshadowMenu";
import { ActionCell } from "./ActionCell/ActionCell";

type TRowCellProps = {
  colId: string;
  data: TTableCompany;
  isFounder?: boolean;
  actionOptions?: ReactNode[];
};

type TCompanyIndexable = TTableCompany & { [key: string]: any };

export function RowCell({ colId, data, isFounder, actionOptions }: TRowCellProps) {
  const field = (data as TCompanyIndexable)[colId];
  const [shownDropshadow, setShownDropshadow] = useState(false);
  switch (colId) {
    case "name":
      return <CompanyCell field={data} isFounder={isFounder} />;
    case "financialStage":
      return <FinancialStageCell field={field} />;
    case "valuation":
      return <ValuationCell field={field} />;
    case "totalFunding":
      return <TotalFundingCell field={field} />;
    case "investors":
      return <InvestorsCell field={field} />;
    case "city":
      return <LocationCell field={data} />;
    case "website":
      return <WebsiteCell field={field} />;
    case "foundingDate":
      return <FoundingDateCell field={field} />;
    case "actions":
      if (!actionOptions || actionOptions.length === 0 || isFounder) return null;
      return (
        <div className={styles.actionsContainer} onClick={(e) => e.stopPropagation()}>
          <DropshadowMenu
            isOpen={shownDropshadow}
            onClose={() => setShownDropshadow(false)}
            options={actionOptions}
            top="0"
            right="0"
            dividerIndexRate={[1, 3]}
          />
          <ActionCell
            field={field}
            onChange={() => {
              setShownDropshadow(true);
            }}
          />
        </div>
      );
    default:
      return null;
  }
}

export function buildCells(portfolioCompany: TTableCompany, isFounder?: boolean, actionOptions?: ReactNode[]) {
  const finalHeaders = !!actionOptions && !isFounder ? [...headers, { label: "Actions", key: "actions" }] : headers;
  return finalHeaders.map((header) => (
    <div key={header.key} className={styles.cell}>
      <RowCell data={portfolioCompany} colId={header.key} isFounder={isFounder} />
    </div>
  ));
}
